import React from 'react';
import { inject, observer } from 'mobx-react';
import { toJS } from 'mobx';
import { Row, Col, Button, Tabs, Input, Spin, BackTop } from 'antd';

const TabPane = Tabs.TabPane;
const Search = Input.Search;
const store = [
  'devStore'
]
@inject(...store)
@observer
class Main extends React.Component {
  static defaultProps = {
    prefixCls: 'dev'
  }
  componentDidMount() {
    const { devStore: { getDevApps } } = this.props;
    this.onWindowResize();
    getDevApps();
    window.onresize = this.onWindowResize;
    window.onscroll = this.onWindowScroll;
  }
  onWindowScroll = () => {
    const coms = this.DevLeft;
    const { devStore: { current, getDevApps, hasMore, setMobxState, loadingApps } } = this.props;
    if (window.location.hash.indexOf('/dev/list') >= 0 && !!coms && !loadingApps && hasMore && this.getLoadBool(coms)) {
      getDevApps({ current: current + 1 });
      setMobxState({ current: current + 1 });
    }
  }
  getLoadBool = (dom) => {
    let t = 0;
    let h = dom.offsetHeight;
    let wt = document.documentElement.scrollTop || document.body.scrollTop;
    let wh = document.documentElement.clientHeight || document.body.clientHeight;
    let _t = wt + wh;
    while (dom.offsetParent) {
      t += dom.offsetTop;
      dom = dom.offsetParent;
    }
    let b = t + h;
    return b < _t
  }
  onWindowResize = () => {
    const { devStore: { setMobxState, activeKey } } = this.props;
    const coms = this.DevLeft;
    if (!!coms) {
      const height = window.innerHeight - coms.offsetTop;
      const singleHeight = activeKey === '0' ? 137 : 114;
      const rows = Math.floor(height / singleHeight);
      const cols = Math.floor((coms.clientWidth - 40) / 120);
      const pageSize = rows <= 3 ? 3 * cols : rows * cols;
      setMobxState({ activeKey: '0', pageSize });
    }
  }
  chooseApp = (v) => {
    const { router, devStore: { setMobxState }, } = this.props;
    setMobxState({
      currentStatus: v.s_status <= 1 ? 1 : v.s_status,
      appType: v.realNumber && v.realNumber.length === 33 ? 2 : 1,
    })
    router.push(`/dev/${v.s_id}/show`);
  }
  getBtnTitle = (status) => {
    if (status === '1') return '发布应用';
    else if (status === '2') return '平台审核';
    return '创建应用';
  }
  onChange = (e) => {
    const { devStore: { setMobxState } } = this.props;
    setMobxState({ devSearchValue: e.target.value });
  }
  onSearch = () => {
    const { devStore: { queryDeapp, setMobxState } } = this.props;
    setMobxState({ current: 1 });
    queryDeapp();
  }
  render() {
    const {
      prefixCls, router,
      devStore: { devApps, setMobxState, activeKey, loadingApps, getDevApps, hasMore, init, devSearchValue },
    } = this.props;
    const tabBarExtraContent = (
      <div>
        <div style={{ display: 'inline-block', marginRight: 10 }}>
          <Search value={devSearchValue} onSearch={this.onSearch} onChange={this.onChange} placeholder="请输入应用编号/应用名称" />
        </div>
        <div style={{ display: 'inline-block' }}>
          <Button icon="plus" type="primary" onClick={() => {
            setMobxState({ appType: 0, currentStatus: 0, member: [], logger: [] });
            router.push(`/dev/apply`);
          }}>发布应用</Button>
        </div>
      </div>
    );
    return (
      <div className={`${prefixCls}`}>
        <Row>
          <Col span={18}>
            <div className={`${prefixCls}-left`}>
              <Tabs
                activeKey={activeKey}
                onChange={(key) => {
                  setMobxState({ activeKey: key });
                  init();
                  getDevApps({ current: 0 });
                }}
                tabBarExtraContent={tabBarExtraContent}>
                <TabPane tab="待发布" key="0" />
                <TabPane tab="已发布" key="1" />
              </Tabs>
              <div ref={el => this.DevLeft = el}>
                {
                  activeKey === '0' ? (
                    <div className={`${prefixCls}-left-apps`}>
                      {
                        // toJS(devApps) && toJS(devApps).map(v => v.s_status !== '3' ? (
                        toJS(devApps) && toJS(devApps).map(v => true ? (
                          <div
                            className={`${prefixCls}-left-apps-single`}
                            key={v.key}
                            onClick={() => this.chooseApp(v)}>
                            <div className={`${prefixCls}-left-apps-single-img`}>
                              <img src={window.server + v.s_pictureNati} alt="" />
                            </div>
                            <div className={`${prefixCls}-left-apps-single-title1 ${prefixCls}-text-elli`} title={v.s_name}>{v.s_name}</div>
                            <div className={`${prefixCls}-left-apps-single-title ${prefixCls}-left-apps-single-title2`}>{this.getBtnTitle(v.s_status)}</div>
                          </div>
                        ) : null)
                      }
                      <div className={`${prefixCls}-clearBoth`} />
                    </div>
                  ) : (
                      <div className={`${prefixCls}-left-apps`}>
                        {
                          // toJS(devApps) && toJS(devApps).map(v => v.s_status === '3' ? (
                          toJS(devApps) && toJS(devApps).map(v => true ? (
                            <div
                              className={`${prefixCls}-left-apps-single`}
                              key={v.key}
                              onClick={() => this.chooseApp(v)}>
                              <div className={`${prefixCls}-left-apps-single-img`}>
                                <img src={window.server + v.s_pictureNati} alt="" />
                              </div>
                              <div className={`${prefixCls}-left-apps-single-title ${prefixCls}-text-elli`} title={v.s_name}>{v.s_name}</div>
                            </div>
                          ) : null)
                        }
                        <div className={`${prefixCls}-clearBoth`} />
                      </div>
                    )
                }
              </div>
            </div>
            {
              loadingApps ? (<Spin spinning={loadingApps}>
                <div className={`${prefixCls}-left-loading`}>加载中</div>
              </Spin>) : !hasMore ? (
                <div className={`${prefixCls}-left-loading`}>没有更多数据啦</div>
              ) : null
            }
          </Col>
          <Col span={6}>
            <div className={`${prefixCls}-right`}>
              <div className={`${prefixCls}-right-con`}>
                <div className={`${prefixCls}-right-con-header`}>开发者指引</div>
                <div className={`${prefixCls}-right-con-body`}>
                  <div className={`${prefixCls}-right-con-body-single`}><a href={`${window.server}/#/oc/doc11`} target="_blank" alt="">如何发布应用</a></div>
                  <div className={`${prefixCls}-right-con-body-single`}><a href={`${window.server}/#/oc/doc21`} target="_blank" alt="">开发规范</a></div>
                  <div className={`${prefixCls}-right-con-body-single`}><a href={`${window.server}/#/oc/doc31`} target="_blank" alt="">基础组件</a></div>
                  <div className={`${prefixCls}-right-con-body-single`}><a href={`${window.server}/#/oc/doc32`} target="_blank" alt="">业务组件</a></div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
        <BackTop />
      </div>
    )
  }
}

export default Main;


// WEBPACK FOOTER //
// ./src/components/dev/DevPortal.js